import { useContext } from 'react';
import { FontSizeContext } from '../context/FontSizeContextValue';

export const useFontScale = () => {
  const ctx = useContext(FontSizeContext);
  if (!ctx) throw new Error('FontSizeProvider missing');
  return ctx;
};
